const hostname = window.location.hostname;

/**
 * Returns the application version based on the current hostname.
 * @param {string} version - The default version to be returned if no match is found. Default set to "v1"
 * @returns {string} - The determined application version.
 */
const getAppVersion = (defaultVersion = 'v1') => {
  // Local override (gitignored .env.local): REACT_APP_APP_VERSION=v1|dev|stage|stage2. Restart the dev server after changing it.
  if (process.env.REACT_APP_APP_VERSION) return process.env.REACT_APP_APP_VERSION;
  const hostname = window.location.hostname;

  if (['staging2', 'testcyf', 'worldlandtrust.compareyourfootprint.com'].some((x) => hostname.includes(x))) return 'stage2';
  if (['staging', 'staging-green'].some((x) => hostname.includes(x))) return 'stage';
  if (/^dev[0-9]+\./.test(hostname) || hostname.includes('sandbox')) return defaultVersion;
  if (['local', 'dev', 'testcyf'].some((x) => hostname.includes(x))) return 'dev';

  return defaultVersion;
};

/**
 * Resolves the API base URL.
 * Priority: REACT_APP_API_URL override → dedicated env host (devN / sandbox) → local test → archer → production.
 */
const resolveApiURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/?$/, '');
  }

  const dedicatedEnv = hostname.match(/^(dev[0-9]+|sandbox)\.app\.compareyourfootprint\.com$/);
  if (dedicatedEnv) {
    // Custom API domains map the stage at the root (no /v1 path prefix).
    const envName = dedicatedEnv[1];
    return `https://api.${envName}.app.compareyourfootprint.com`;
  }

  if (hostname.includes('local') && process.env.REACT_APP_LOCAL_BACK_TEST) {
    return process.env.REACT_APP_LOCAL_API_URL || 'https://localhost:3001';
  }

  if (hostname.includes('archerirm')) {
    return `https://api.archerirm.compareyourfootprint.com/${getAppVersion()}`;
  }

  return `https://api.app.compareyourfootprint.com/${getAppVersion()}`;
};

const apiURL = resolveApiURL();
const paymentURL = apiURL;
// const paymentURL = 'http://localhost:3002';

module.exports = { apiURL, paymentURL, getAppVersion };
